import { SpriteView } from './SpriteView.ts';
import { ViewAnimationControllerAdapter } from './animation/ViewAnimationControllerAdapter.ts';
export class MovingSpriteView extends SpriteView {
    constructor(x, y, w, h, container, texture, padding = 0){
        super(x, y, w, h, container, texture, padding);
        this.animationController = new ViewAnimationControllerAdapter(this);
    }
}
